import React from "react";
import { Container } from 'react-bootstrap';

const VideoQuienes = () => {
    return (
        <Container className="my-4">
          <div className="container-responsive-iframe">
            <iframe
              class="responsive-iframe"
              src="https://www.youtube.com/embed/qPe7Twew5G4"
              title="YouTube video"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
        </Container>
      );
    };

export default VideoQuienes;

